const API_BASE_URL = import.meta.env.VITE_APP_BASE_URL + '/api';

class APIError extends Error {
    status: number;
    details: unknown;

    constructor(status: number, message: string, details?: unknown) {
        super(message);
        this.name = 'APIError';
        this.status = status;
        this.details = details;
    }
}

async function fetchApi<T>(
    method: 'GET' | 'POST' | 'PUT' | 'DELETE',
    path: string,
    body?: unknown,
    customInit?: RequestInit
): Promise<T> {
    const headers: HeadersInit = {
        'Content-Type': 'application/json',
        ...(customInit?.headers || {})
    };

    const res = await fetch(`${API_BASE_URL}${path}`, {
        method,
        headers,
        body: body ? JSON.stringify(body) : undefined,
        ...customInit
    });

    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new APIError(
            res.status,
            errorData.message || 'Request failed',
            errorData
        );
    }

    return res.json() as Promise<T>;
}

export const http = {
    get: <T>(path: string, init?: RequestInit) =>
        fetchApi<T>('GET', path, undefined, init),
    post: <T>(path: string, body: unknown, init?: RequestInit) =>
        fetchApi<T>('POST', path, body, init),
    put: <T>(path: string, body: unknown, init?: RequestInit) =>
        fetchApi<T>('PUT', path, body, init),
    delete: <T>(path: string, init?: RequestInit) =>
        fetchApi<T>('DELETE', path, undefined, init)
};
